import React from 'react'

interface ArrowButtonProps {
  direction: 'left' | 'right'
  onClick: () => void
  disabled: boolean
  isTransitioning: boolean
}
/* istanbul ignore next - arrow button is rendered in the carousel component and tested e2e */
const ArrowButton = ({ direction, onClick, disabled, isTransitioning }: ArrowButtonProps) => {
  const isTransitioningClass = isTransitioning ? 'transitioning' : ''

  return (
    <button className={`carousel-arrow ${direction} ${isTransitioningClass}`} onClick={onClick} disabled={disabled}>
      {direction === 'left' ? <span>&lt;</span> : <span>&gt;</span>}
    </button>
  )
}

export default ArrowButton
